import Checkbox from 'components/Inputs/Checkbox';
import { useTranslations } from 'next-intl';

export default function ConfigureVisible({ keys, renderKeys, setRenderKeys, labels }) {
  const t = useTranslations();

  return (
    <>
      <h2 className="subtitle1">{t('configure_visible.header')}</h2>
      <p>{t('configure_visible.explanation')}</p>

      <div className="row-gap-05 mb-5 grid">
        {keys.map((key) => (
          <div key={key} className="gcol-4 align-items-start flex">
            <Checkbox
              label={labels(key)}
              onChange={() => setRenderKeys({ ...renderKeys, [key]: !renderKeys[key] })}
              checked={!!renderKeys[key]}
              className="my-4"
            />
          </div>
        ))}
      </div>
    </>
  );
}
